module.exports = __webpack_public_path__ + "img/icon_enjoy_outlined.063e6615.svg";